import React, { memo } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'
import { IFullStop } from 'types'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { formatDateTime } from 'apps/fleet-planner/components/load-details/stops/utils'
import { standardFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { InfoIcon } from 'transfix-icons'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'
import { InlineRow } from '../../../components/load-details/InlineRow'
import { StopHeader } from '../../../components/load-details/stops/StopInlineEditContainer'
import { MarketplaceFacilityDetails } from './MarketplaceFacilityDetails'
import { MarketplaceStopDetailsDisplay } from './MarketplaceStopDetailsDisplay'

interface IMarketplaceStopSection {
  stop: IFullStop
  sequence: number
}

export const MarketplaceStopSection = memo<IMarketplaceStopSection>(({ sequence, stop }) => {
  const { appointment, info, type } = stop || {}
  const { getFlag } = useFeatureFlagContext()
  const { enabled: fmsLoadDetailsInformation } = getFlag('fmsLoadDetailsInformation')
  const { enabled: hideFacilityAddress } = getFlag('hideFacilityAddress')
  const { shipmentDetails } = useMarketplaceContext()
  const { info: shipmentInfo } = shipmentDetails || {}
  const { carrierId, isHighRisk } = shipmentInfo || {}
  const hideFacilityDetails = isHighRisk && !carrierId && hideFacilityAddress
  const { appointmentType, endAt, startAt, timezone: displayTimezone } = appointment || {}
  const { specialInstruction } = info || {}
  const stopType = capitalize(type)
  return (
    <Card className='mt4 mb4'>
      <StopHeader
        showDropTrailer={stop?.isDropTrailer}
        // Fix this TS error later.
        stopType={type}
        sequence={sequence}
      />
      {!hideFacilityDetails && (
        <InlineRow
          bodyClass='mt1'
          rowTitle={`${stopType} Location`}
          rowBody={<MarketplaceFacilityDetails stop={stop} />}
        />
      )}
      <InlineRow
        bodyClass='mt1'
        rowTitle='Appointment'
        rowBody={
          <span data-test={`appointment-time-${stopType}-${sequence}`}>
            {formatDateTime(standardFormats, startAt, endAt, displayTimezone)}
            {appointmentType === 'FCFS' && ' FCFS'}
          </span>
        }
      />
      <InlineRow
        bodyClass='mt1'
        rowTitle={`${stopType} Details`}
        rowBody={<MarketplaceStopDetailsDisplay stop={stop} />}
      />
      {fmsLoadDetailsInformation && (
        <InlineRow
          bodyClass='mt1'
          rowTitle={`${stopType} Instructions`}
          rowBody={<span>{specialInstruction || DISPLAY.empty}</span>}
        />
      )}
      {hideFacilityDetails && (
        <Box display='flex' alignItems='center'>
          <Box display='flex' alignItems='center' mr={1}>
            <InfoIcon color='coolGray6' />
          </Box>
          <Typography variant='body2'>{`${stopType} facility location and additional info will be provided after booking`}</Typography>
        </Box>
      )}
    </Card>
  )
})
